
import react from 'react';
import { Radio, Input, Form, Select, DatePicker} from 'antd';
function PersonalInfo() {
    const { Option } = Select;
    return (
        <div className="personalInfo">
            <Form>
                <Form.Item className="formInput"
                    label="Số giấy tờ"
                    name="document_Number"
                >
                    <Input />
                </Form.Item>
                <Form.Item className="formInput"
                    label="họ và tên"
                    name="fullname"
                >
                    <Input />
                </Form.Item>
                <div className="row">
                    <div className="col-lg-6 col-12 col-md-6">
                        <Form.Item className="formInput"
                            label="Quốc tịch"
                            name="national"
                        >
                            <Select placeholder="Chọn Quốc tịch" >
                                <Option value="CCCD">Việt nam</Option>
                                <Option value="CMND">Trung quốc</Option>
                                <Option value="HC">Nhật bản</Option>
                                <Option value="BLX">Hàn quốc</Option>
                            </Select>
                        </Form.Item>
                    </div>
                    <div className="col-lg-6 col-12 col-md-6">
                        <Form.Item className="formInput"
                            label="Ngày sinh"
                            name="birthdate"
                        >
                            <DatePicker  placeholder="yyyy-mm-dd" />
                        </Form.Item>

                    </div>
                </div>
                <Form.Item className="formInput"
                    label="Giới tính"
                    name="gender"
                >
                    <Radio.Group value="M" className="radioStyle">
                        <Radio value="M">Nam</Radio>
                        <Radio value="F">Nữ</Radio>
                    </Radio.Group>
                </Form.Item>
            </Form>
            <Form.Item className="formInput"
                label="NƠI ĐĂNG KÍ HỘ KHẨU THƯỜNG TRÚ"
                name="Nhập nơi đăng ký họ khẩu thường trú"
            >
                <Input />
            </Form.Item>
            <Form.Item className="formInput"
                label="NGÀY HẾT HẠN"
                name=""
            >
                <DatePicker placeholder="yyyy-mm-dd"  />
            </Form.Item>
            <div className="note"><img className="img-fluid" src="/images/privacy.png" alt="" />Thông tin của JO được bảo mật tuyệt đối
            </div>
            <Form.Item className="btnUpload">
                <button className="btnStyle">Cập nhật</button>
            </Form.Item>
        </div>
    );
}
export default PersonalInfo;